import { render, staticRenderFns } from "./SkpNonTerstruktur.vue?vue&type=template&id=193c4e40&"
import script from "./SkpNonTerstruktur.vue?vue&type=script&lang=js&"
export * from "./SkpNonTerstruktur.vue?vue&type=script&lang=js&"
import style0 from "./SkpNonTerstruktur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports